export default __webpack_public_path__ + "increase-indent.52a7a14a59f1f27e.svg";